var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0845",
    d: "M12 6c-2.756 0-5 2.304-5 5.133 0 2.673 2.001 4.878 4.545 5.114v1.109h-1.212c-.25 0-.454.208-.454.466s.203.467.454.467h1.212v1.244c0 .258.204.467.455.467s.455-.209.455-.467V18.29h1.212c.25 0 .454-.21.454-.467a.46.46 0 00-.454-.466h-1.212v-1.109C14.999 16.011 17 13.806 17 11.133 17 8.303 14.756 6 12 6zm0 .933c2.265 0 4.09 1.875 4.09 4.2s-1.825 4.2-4.09 4.2c-2.265 0-4.09-1.875-4.09-4.2s1.825-4.2 4.09-4.2z"
  })));
}
export default SvgFemale;